import type { Venue } from "../lib/settings";
import { useSettings } from "../store/useSettings";

/**
 * Площадка формы ордера: Polymarket или проба predict.fun (ADR-0040).
 *
 * Стоит над формой рядом с выбором аккаунта и действует только на форму: у
 * Polymarket выбор аккаунта и когорт, у predict.fun его нет — один кошелёк.
 * Без пары у окна вариант predict.fun выключен, а не спрятан: иначе
 * переключатель то появлялся бы, то исчезал между окнами.
 */
export function VenueSwitch({ paired }: { paired: boolean }) {
  const venue = useSettings((s) => s.settings.venue);
  const setVenue = useSettings((s) => s.setVenue);
  const options: { id: Venue; label: string }[] = [
    { id: "polymarket", label: "Polymarket" },
    { id: "predict", label: "predict.fun" },
  ];
  return (
    <div className="flex shrink-0 overflow-hidden rounded border border-[var(--color-border)] text-xs">
      {options.map((o) => {
        const on = venue === o.id;
        const disabled = o.id === "predict" && !paired;
        return (
          <button
            key={o.id}
            type="button"
            disabled={disabled}
            onClick={() => setVenue(o.id)}
            className="px-2 py-1 font-medium disabled:opacity-40"
            style={{
              background: on ? "var(--color-border)" : "transparent",
              color: on ? "var(--color-fg)" : "var(--color-muted)",
            }}
            title={disabled ? "у этого окна нет пары на predict.fun (только BTC/ETH/SOL 5m и 15m)" : undefined}
          >
            {o.label}
          </button>
        );
      })}
    </div>
  );
}
